import React from "react";

function Loading() {
  return (
    <>
      <div className="loading"></div>
      <div className="text">Loading</div>
    </>
  );
}

export default Loading;
